<template>
  <div class="seckill-header">
    <scroll-view ref="tabWrap" class="tab-wrap" scroll-x>
      <div
        v-for="(tab, index) in formatTabList"
        :key="tab.scene_id"
        :class="[
          'tab',
          tab.status !== 2 ? 'will-start' : '',
          activeIndex === index ? 'active' : '',
          formatTabList.length < 5 ? 'average' : ''
        ]"
        @click.stop="switchTab(index, $event, tab)"
      >
        <span class="time">{{ tab.tabTime }}</span>
        <span class="status-str">{{ tab.statusStr }}</span>
      </div>
    </scroll-view>
  </div>
</template>

<script>
import ScrollView from '@/common/widget/ScrollView/index.vue'

import { compareTimeInOneDay, ScrollAnimate } from '@/utils/utils'

const scrollAnimate = new ScrollAnimate({
  direction: 'HORIZONTAL'
})

const statusMap = [
  {
    statusStr: '即将开抢'
  },
  {
    statusStr: '抢购中'
  },
  {
    statusStr: '已结束'
  },
  {
    statusStr: '明天开抢'
  }
]
export default {
  name: 'Tab',
  components: {
    ScrollView
  },
  props: {
    tabList: {
      type: Array,
      default: () => []
    },
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      currentTime: '' // 当前时间
    }
  },
  computed: {
    // 格式化tab栏数据
    formatTabList() {
      const currentTime = new Date(this.currentTime || new Date().getTime())
      return this.tabList.map((tabItem, index) => {
        const startTime = new Date(tabItem.startTime * 1000)
        const endTime = new Date(tabItem.endTime * 1000)

        const startArr = [
          startTime.getHours(),
          startTime.getMinutes()
        ].map(item => this.numAddZero(item))
        const tabTime = startArr[0] + ':' + startArr[1]

        let status
        let statusStr

        if (tabItem.scene_status === 3) {
          // 明天开始
          status = 3
        } else if (!compareTimeInOneDay(currentTime, startTime)) {
          // 今天未开始
          status = 0
        } else if (!compareTimeInOneDay(currentTime, endTime)) {
          // 今天抢购中
          status = 1
        } else {
          // 今天已结束
          status = 2
        }

        statusStr = statusMap[status].statusStr
        // 抢购中的小于1小时
        if (status === 1) {
          let remainingTimer = endTime.getTime() - currentTime.getTime() // 当前状态剩余时间（进行中: 还有多久结束）
          if (remainingTimer < 60 * 60 * 1000) {
            remainingTimer = Math.floor(remainingTimer / 1000)
            statusStr = [
              this.numAddZero(Math.floor(remainingTimer / 3600) % 24),
              this.numAddZero(Math.floor(remainingTimer / 60) % 60),
              this.numAddZero(remainingTimer % 60)
            ].join(':')
          }
        }

        return {
          startTime,
          endTime,
          tabTime,
          statusStr,
          status,
          spm: tabItem.spm
        }
      })
    },
    activeTab() {
      return this.formatTabList[this.activeIndex] || {}
    }
  },
  watch: {
    activeTab(n, o) {
      this.$emit('update:activeTab', n)
    },
    activeIndex: {
      handler: function (newval) {
        // 选中的标签居中
        this.$nextTick(() => {
          scrollAnimate.scrollTo({
            el: this.$refs.tabWrap.$el,
            start: this.$refs.tabWrap.$el.scrollLeft,
            end: this.calScrollLeft(newval)
          })
        })
      },
      immediate: true
    }
  },
  created() {
    this.currentTime = new Date().getTime()
    this.refreshTime()
  },
  methods: {
    // 数字补零函数
    numAddZero(num) {
      return ('00' + num).slice(-2)
    },
    // 切换tab
    switchTab(index, event, tab) {
      this.$emit('set-active-index', index)
      const tabInfo = Array.isArray(this.tabList) && this.tabList[index]
      this.$track(tab.spm.tab, {
        scene_id: tabInfo.scene_id,
        scene_status: tabInfo.scene_status,
        scene_time: tabInfo.scene_time
      })
    },
    // 计算tab滚动距离
    calScrollLeft(toIndex) {
      const screenWidth = window.innerWidth
      let target
      const singleWidth = Math.floor(screenWidth * 0.2)
      const leftPosX = 2 // (index < this.tabList.length / 2)? 0.5: 2.8; // 据左边栏的身位
      target = Math.floor((toIndex - leftPosX) * singleWidth)
      target = Math.max(0, target)
      target = Math.min(this.tabList.length * singleWidth - screenWidth, target)
      return target
    },
    // 定时更新时间
    refreshTime() {
      setInterval(
        function () {
          this.currentTime = new Date().getTime()
        }.bind(this),
        1000
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.tab-wrap {
  display: flex;

  width: 100%;

  height: 1.18rem;

  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  flex-flow: row, nowrap;

  // 滚动回弹效果（解决滚动卡顿问题）
  -webkit-overflow-scrolling: touch;

  writing-mode: initial !important;

  // 隐藏滚动条
  &::-webkit-scrollbar {
    display: none;

    background-color: transparent;
  }
}
.tab {
  position: relative;

  width: 20vw;
  height: 100%;
  padding-top: 0.04rem;
  padding-bottom: 0.18rem;

  flex: none;

  color: #fff;
  box-sizing: border-box;
  @include flex(column, flex-start, center, nowrap);

  .time {
    opacity: 0.6;

    font-size: 0.4rem;
    line-height: 0.56rem;
    font-weight: 500;
  }
  .status-str {
    opacity: 0.6;

    font-size: 0.28rem;
    line-height: 0.4rem;
  }

  &.will-start {
    .time,
    .status-str {
      opacity: 1;
    }
  }

  &.average {
    flex: 1;
  }

  &.active {
    .time {
      opacity: 1;
    }
    .status-str {
      padding: 0 0.1rem;

      background-color: #fff;
      border-radius: 0.25rem;
      opacity: 1;

      color: #f03100;
    }

    &:after {
      display: block;

      position: absolute;
      bottom: 0px;
      left: 50%;
      transform: translateX(-50%);

      border: 7px solid transparent;
      border-bottom: 7px solid #f5f5f5;

      content: '';
    }
  }
}
</style>
